module.exports = __webpack_public_path__ + "static/img/logo_en_2025.d75e19b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/en/logo_en_2025.png
// module id = CA32
// module chunks = 100